import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { CurrencyInformationClipboard } from '@root/entities/currency/ui'
import { PairIcon, PairTicker } from '@root/entities/pair/ui/common'
import { Truncate } from '@root/shared/ui-kit'

import type { PairModel } from '@root/entities/pair'
import type { ClassNameProps } from '@root/shared/react'

type Props = {
  pair: PairModel
} & ClassNameProps

export const PositionsTableCurrencyCell: React.FC<Props> = ({
  className,
  pair,
}) => {
  return (
    <Root className={className}>
      <PairIcon pair={pair} size={28} withPairPopover withGoogleLens={false} />
      <Info>
        <PairTicker pair={pair} />
        <AddressContainer>
          <Address ellipsis>
            <Truncate start={4} end={4}>
              {pair.quote.address}
            </Truncate>
          </Address>
          <CurrencyInformationClipboard size={12} currency={pair.quote} />
        </AddressContainer>
      </Info>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 8px;
  padding-inline: 0 4px;
`

const Info = styled.div`
  display: grid;
`

const Address = styled(Typography)`
  color: var(--text-11);
  font-weight: 600;
  font-size: 10px;
  line-height: auto;
`

const AddressContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  gap: 2px;
`
